<template>
  <div class="mod-home">
    <el-card class="box-card">
  
  <div class="item">
        <b class="cardtitle">宝通街南支路项目</b>
    <el-row :gutter="22">
  <el-col :span="24">
<table cellpading="0" cellspacing="0" class="tablebody">
  <tbody>
    <tr>
    <td width="120">项目编号</td>
    <td></td>
    <td width="120">施工单位</td>
    <td colspan="3">第一建筑工程公司</td>
    <td width="120">项目日期</td>
    <td>2021/4/1</td>
  </tr>
  <tr>
    <td>合同金额（元）</td>
    <td>{{interval.interval(205368)}}</td>
    <td>实用金额（元）</td>
    <td>{{interval.interval(205368)}}</td>
    <td width="130">实用方量（m³）</td>
    <td>692</td>
    <td width="130">车间</td>
    <td>搅拌站</td>
  </tr>
    <tr>
    <td>进度应收款（元）</td>
    <td>{{interval.interval(205368)}}</td>
    <td>已回款（元）</td>
    <td>{{interval.interval(205368)}}</td>
    <td>应收款（元）</td>
    <td>{{interval.interval(205368)}}</td>
    <td>应收款比例</td>
    <td>30%</td>
  </tr>
      <tr>
    <td>付款方式</td>
    <td colspan="7" style="text-align:left;padding-left:10px">月付75%，主体完成付至85%，竣工验收付95%，剩余5%为质保金，自竣工验收合格之日起，期满两年后无息付清</td>
  </tr>
  </tbody>
</table>

  </el-col>

</el-row>
  </div>
</el-card>
 <el-card class="box-card">
 <div class="item">
<b class="cardtitle">项目进度</b>

<el-steps :active="active" finish-status="finish" align-center>
  <el-step title="2021-04-01" @click.native="next(1)" description="进入现场,11#1层开始施工"></el-step>
  <el-step title="2021-05-01" @click.native="next(2)" description="12#1层开始施工"></el-step>
  <el-step title="2021-07-05" @click.native="next(3)"  description="17#1层开始施工中"></el-step>
</el-steps>

 </div>
</el-card>
    <el-card class="box-card">
  
  <div class="item">
        <b class="cardtitle">已收款信息</b>
    <el-row :gutter="22">
  <el-col :span="24">

  <el-table :data="tableData" border style="width: 100%" :header-cell-style="{textAlign: 'center'}">
      <el-table-column prop="date" label="日期" width="100"> </el-table-column>
      <el-table-column prop="amount0" label="付款项目"> </el-table-column>
      <el-table-column prop="amount1" label="付款金额（元）" width="130"> </el-table-column>
      <el-table-column prop="amount2" label="备注"> </el-table-column>
    </el-table>
  </el-col>

</el-row>
  </div>
</el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
active:1,
  tableData: [{
          date: '2016-04-01',
          amount0: '首付款',
          amount1: '300',
          amount2: '合同签订十个工作日付30%'
        },{
         date: '2016-04-01',
          amount0: '主体完成款',
          amount1: '500',
          amount2: '主体完成付至50%',
        }]
    };
  },
  created() {},
  methods: {
     next(status) {
        this.active = status
        if(status==1){
 this.tableData= [{
          date: '2016-04-01',
          amount0: '5220',
          amount1: '首付款',
          amount2: '5220',
          amount3: '主体完成付至85',
        },{
         date: '2016-04-01',
          amount0: '5220',
          amount1: '主体完成款',
          amount2: '5220',
          amount3: '主体完成付至85%',
        }]
        }
        if(status==2){
 this.tableData= [{
          date: '2016-05-01',
          amount0: '5220',
          amount1: '首付款',
          amount2: '5220',
          amount3: '主体完成付至85',
        },{
         date: '2016-05-01',
          amount0: '5220',
          amount1: '主体完成款',
          amount2: '5220',
          amount3: '主体完成付至85%',
        }]
        }
        if(status==3){
 this.tableData= [{
          date: '2016-07-05',
          amount0: '5220',
          amount1: '首付款',
          amount2: '5220',
          amount3: '主体完成付至85',
        },{
         date: '2016-07-05',
          amount0: '5220',
          amount1: '主体完成款',
          amount2: '5220',
          amount3: '主体完成付至85%',
        }]
        }
      }
  },
};
</script>

<style>
.mod-home {
  line-height: 1.5;
}

.box-card{margin-bottom: 20px;}
.tablebody{width: 100%;border:1px solid #EBEEF5;border-top: 0; border-right: 0;}
.tablebody tr td{border:1px solid #EBEEF5;border-bottom: 0; border-left: 0;padding: 10px;}
</style>

